import React from 'react'
import { GiHamburgerMenu } from 'react-icons/gi';
import { CgClose } from 'react-icons/cg';
import './NavbarMobile.css';
function Navbarmobile(props) {

    return (
        <div {...props} style={{
            height: "4rem", position: "fixed", width: "100%", alignItems: "center",
            justifyContent: "space-between", background: "#0E2D4C", zIndex: 1000
        }}>
            <nav className="navbar d-flex w-100 justify-content-between">

                <span><img style={{ width: "6rem", paddingLeft: "0.5em" }} src="/images/sreenidhiL.jpg" /></span>
                <span >
                    {
                        props.mobileCollapseSidebar ?
                            < CgClose id="navBarClose" style={{ color: "white", fontSize: "1.6em", marginRight: "5px" }} onClick={props.onMobileCollapseHandler} />

                            :
                            < GiHamburgerMenu id="navBarMenu" style={{ color: "white", fontSize: "2em", marginRight: "5px" }} onClick={props.onMobileCollapseHandler} />
                    }
                </span>

            </nav>
        </div>

    )
}

export default Navbarmobile